import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'cx_foundations-self_service_init-view';
/**
 * Record the loading event when it&#39;s at the first page in contact us flow.
 */
export function trackCxFoundationsSelfServiceInitView(retailerToken, brandToken) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { retailerToken, brandToken },
    });
}
